import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

export default function WriteOnlyButton(props) {
  const loggedUserContext = useSelector((state: RootState) => state.user.context);

  return <Button {...props} disabled={props.disabled || loggedUserContext.readonly} />;
}
